import createApiClient from "./api";

const api = createApiClient();

export const fetchAuthorizationRequest = async (requestId) => {
  const response = await api.get(`/oauth/authorize/requests/${encodeURIComponent(requestId)}`);
  return response.data;
};

export const submitAuthorizationDecision = async (requestId, approve) => {
  const response = await api.post(
    `/oauth/authorize/requests/${encodeURIComponent(requestId)}/decision`,
    { approve }
  );
  return response.data;
};
